import { PopupRequest } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { message } from 'antd';
import React from 'react';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { Typography } from 'tfc-components';

import Button from 'components/atoms/Button';
import { loginRequest } from 'configs/authConfig';
import { verifySocialService } from 'services/auth';
import { setAccessToken, setRefreshToken } from 'services/common/storage';
import { getProfileAction } from 'store/auth';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getSystemAction } from 'store/system';
import { LOCAL_STORAGE, ROUTE_PATHS } from 'utils/constants';

const MicrosoftLogin = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { instance } = useMsal();
  const { system } = useAppSelector((state) => state.system);

  const { mutate: handleLoginSocial, isLoading } = useMutation(['verifySocialMutate'], verifySocialService, {
    onSuccess(data) {
      const { accessToken, refreshToken } = data;
      setAccessToken(accessToken);
      setRefreshToken(refreshToken);
      dispatch(getProfileAction())
        .unwrap()
        .then((res) => {
          if (res) {
            localStorage.removeItem(LOCAL_STORAGE.SOCIAL_PKCE_STATE);
            localStorage.removeItem(LOCAL_STORAGE.SOCIAL_PKCE_UUID);
            if (!res.customerData.onboardingFlow) {
              navigate(ROUTE_PATHS.ONBOARDING);
            } else {
              navigate(ROUTE_PATHS.AGENT);
            }
          }
        });
    },
    onError() {
      navigate(ROUTE_PATHS.LOGIN);
      message.error('Login fail! Please double check.');
    },
  });

  const handleLogin = async () => {
    let currentSystem = system;
    if (!currentSystem) {
      currentSystem = await dispatch(getSystemAction()).unwrap();
    }

    const microsoftScopes = currentSystem?.others?.microsoft?.scopes;
    const customLoginRequest: PopupRequest = {
      ...loginRequest,
      scopes: [...(currentSystem?.others?.microsoft?.oboScopes || [])],
      extraScopesToConsent: [...(microsoftScopes || loginRequest.scopes)]
    };

    const loginResponse = await instance.loginPopup(customLoginRequest);
    if (loginResponse.accessToken) {
      handleLoginSocial({
        provider: 'microsoft',
        token: loginResponse.accessToken,
      });
    }
  };

  return (
    <Button
      type="button"
      icon={{ align: 'left', name: 'microsoft', size: '24' }}
      onClick={handleLogin}
      disabled={isLoading}
    >
      <Typography.Text fontweight="600" extendClasses="o-loginSocials_google-text">
        Continue with Microsoft
      </Typography.Text>
    </Button>
  );
};

export default MicrosoftLogin;
